module.exports = __webpack_public_path__ + "assets/3e51a876e64628fb3548d66d273af459.woff2";